.sponsors {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.sponsors>* {
    margin: var(--space-medium);
}

@media screen and (width <=415px) {
    .sponsors {
        justify-content: space-evenly;
    }
}